import PropTypes from 'prop-types';
import React from 'react';

export const CandleTrailWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'CANDLE_TRAIL',
    category: 'Exit',
    type: 'Candle Trail',
    domain: 'Underlying',
  };
  const priceToBreak = softOrder.priceToBreak;
  const candleDuration = softOrder.candleDuration;
  const breakBy = softOrder.breakBy;

  return (
    <Component
      details={details}
      candleDuration={candleDuration}
      priceToBreak={priceToBreak}
      breakBy={breakBy}
      {...rest}
    />
  );
};

CandleTrailWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    breakBy: PropTypes.any,
    candleDuration: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};

